import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import clsx from 'clsx'
import ResponsiveImage from 'components/images/responsive-image'
import ScrollLoader from 'components/shared/scroll-loader'
import { PURPOSE_IMAGE_GROUP, PURPOSE_LOOKBOOK } from 'pages/purpose/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { BUTTON_TYPES } from 'constants/button'
import Button from 'components/common/button'
import Typo from 'constants/typography'
import styles from './styles.scss'

const PurposeImageGroup = ({ t }) => (
  <React.Fragment>
    <style jsx>{styles}</style>
    <span className={clsx('purpose-ig__subtitle', Typo.body2)}>
      {hasLocizeTranslation(
        t,
        PURPOSE_IMAGE_GROUP.subtitleKey,
        PURPOSE_IMAGE_GROUP.subtitle,
      )}
    </span>
    {PURPOSE_IMAGE_GROUP.images.map((image, idx) => (
      <ScrollLoader key={image.src}>
        <ResponsiveImage
          className={clsx(Typo.h6, 'purpose-ig__image', `image-${idx + 1}`)}
          imgRatio={PURPOSE_IMAGE_GROUP.imagesRatio}
          src={image.src}
        >
          <div className="overlay">
            {hasLocizeTranslation(t, image.descKey, image.desc)}
          </div>
        </ResponsiveImage>
      </ScrollLoader>
    ))}
    <Link href={PURPOSE_LOOKBOOK.lookbookHref} as={PURPOSE_LOOKBOOK.lookbookAs}>
      <a>
        <Button type={BUTTON_TYPES.primary} className="purpose-ig__lookbook">
          {hasLocizeTranslation(
            t,
            PURPOSE_IMAGE_GROUP.lookbookKey,
            PURPOSE_IMAGE_GROUP.lookbook,
          )}
        </Button>
      </a>
    </Link>
  </React.Fragment>
)

PurposeImageGroup.propTypes = {
  t: PropTypes.func.isRequired,
}

export default PurposeImageGroup
